import { ReactNode } from "react";
import { APP_COLORS } from "../../enums";
import {
  ProfileCompletionProgressWrapper,
  ProfileCompletionProgressGradient,
  ProfileCompletionProgressBackground,
  ProfileCompletionProgressForeground,
  ProfileCompletionProgressContent,
} from "./completion-graph.styles";

interface CompletionGraphProps {
  percentage: number;
  size?: number;
  thickness?: number;
  children?: ReactNode;
}

function CompletionGraph({
  percentage,
  size = 168,
  thickness = 4,
  children,
}: CompletionGraphProps) {
  return (
    <ProfileCompletionProgressWrapper>
      <ProfileCompletionProgressGradient>
        <defs>
          <linearGradient
            id="profileProgressGradient"
            x1="0%"
            y1="0%"
            x2="0%"
            y2="100%"
          >
            <stop offset="0%" stopColor={APP_COLORS.successLight3} />
            <stop offset="100%" stopColor={APP_COLORS.successDark2} />
          </linearGradient>
        </defs>
      </ProfileCompletionProgressGradient>
      <ProfileCompletionProgressBackground
        variant="determinate"
        size={size}
        thickness={thickness}
        value={100}
      />
      <ProfileCompletionProgressForeground
        variant="determinate"
        size={size}
        thickness={thickness}
        value={percentage}
      />
      {children && (
        <ProfileCompletionProgressContent>{children}</ProfileCompletionProgressContent>
      )}
    </ProfileCompletionProgressWrapper>
  );
}

export default CompletionGraph;
